import { ComponentCategory, CrossSectionCategory, VisualConditionCategory, type DatabaseType } from '../typeSheet';

export const exampleData: DatabaseType = {
  buildings: [
    {
      _id: '0',
      location: {
        longitude: 56.16906618295538,
        latitude: 10.157261935492112,
        height: 10
      },
      address: 'Bispehavevej 85, 8210 Aarhus',
      ownerId: '',
      formerUse: '',
      gfa: 0,
      complexity: 0,
      img: '',
      type: 'BuildingType'
    }
  ],
  users: [],
  components: [
    {
      _id: '0',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/1-8',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16908534794102,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: [
        {
          reboundValue: [1, 2, 3, 4, 5],
          reboundDate: '',
          userId: '',
          location: {
            longitude: 56.16908534794102,
            latitude: 10.157380513109615,
            height: 13
          }
        },
        {
          reboundValue: [12, 14, 15, 16, 17],
          reboundDate: '',
          userId: '',
          location: {
            longitude: 56.16908534794102,
            latitude: 10.157380513109615,
            height: 13
          }
        }
      ]
    },
    {
      _id: '1',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Fair,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/9-16',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16912915362248,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '2',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Discard,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/21-24',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1691839107243,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '3',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '4',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '5',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/41-44',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929342492794,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '6',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/49-52',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1693372306094,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '7',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '8',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '9',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/69-72',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169446744813044,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '10',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/77-84',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169501501914866,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '11',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'U-Y/85-92',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16954530759632,
        latitude: 10.157380513109615,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '12',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/1-8',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16908534794102,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '13',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/9-16',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16912915362248,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '14',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/21-24',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1691839107243,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '15',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '16',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '17',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/41-44',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929342492794,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '18',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/49-52',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1693372306094,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '19',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '20',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '21',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/69-72',
      yaw: 0,
      geometryTypeId: '1',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169446744813044,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '22',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/77-84',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169501501914866,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '23',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'Q-T/85-92',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16954530759632,
        latitude: 10.157356258596945,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '24',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/1-6',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16907987223084,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '25',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/7-12',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16911272649194,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '26',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/3-18',
      yaw: 180,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169118202202114,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '27',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/19-24',
      yaw: 0,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16917843501412,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '28',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '29',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '30',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/41-46',
      yaw: 0,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929890063813,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '31',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/47-52',
      yaw: 0,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16933175489922,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '32',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '33',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '34',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/69-74',
      yaw: 0,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169452220523226,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '35',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'O-P/75-80',
      yaw: 0,
      geometryTypeId: '3',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16948507478432,
        latitude: 10.157340088921831,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '36',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/81-86',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16951792904541,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '37',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'M-P/87-92',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169550783306505,
        latitude: 10.157334699030125,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '38',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/1-6',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16907987223084,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '39',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/7-12',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16911272649194,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '40',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/13-15',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16913736718775,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '41',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/16-18',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1691537943183,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '42',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/19-21',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169170221448844,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '43',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/22-24',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16918664857939,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '44',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '45',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '46',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/41-44',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929342492794,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '47',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/44-46',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1693071142034,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '48',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/47-49',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16932354133395,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '49',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/50-52',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16933996846449,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '50',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '51',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '52',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/69-71',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16944400695795,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '53',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/72-74',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.1694604340885,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '54',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/75-77',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169476861219046,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '55',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-N/78-80',
      yaw: 90,
      geometryTypeId: '4',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16949328834959,
        latitude: 10.157318529355011,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '56',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/81-86',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16951792904541,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '57',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'I-L/87-92',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169550783306505,
        latitude: 10.157313139463307,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '58',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/1-6',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16907987223084,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '59',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/7-12',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16911272649194,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '60',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/13-18',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169145580753025,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '61',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/19-24',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16917843501412,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '62',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '63',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '64',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/41-46',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929890063813,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '65',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/47-52',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16933175489922,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '66',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '67',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '68',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/69-74',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169452220523226,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '69',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/75-80',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16948507478432,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '70',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/81-86',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16951792904541,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '71',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'E-H/87-92',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169550783306505,
        latitude: 10.157291579896489,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '72',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/1-6',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16907987223084,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '73',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/7-12',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16911272649194,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '74',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/13-18',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169145580753025,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '75',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/19-24',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16917843501412,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '76',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/25-32',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16921676498539,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '77',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/33-40',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16926057066685,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '78',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/41-46',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16929890063813,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '79',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/47-52',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16933175489922,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '80',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/53-60',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16937008487049,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '81',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/61-68',
      yaw: 0,
      geometryTypeId: '0',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16941389055195,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '82',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/69-74',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169452220523226,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '83',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/75-80',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16948507478432,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '84',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/81-86',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.16951792904541,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    },
    {
      _id: '85',
      buildingId: '0',
      img: [],
      manufacturerId: '',
      condition: VisualConditionCategory.Good,
      noHarmfulSubstance: false,
      availableFrom: '',
      buyer: '',
      price: 0,
      loadingCondition: '',
      planReference: 'A-D/87-92',
      yaw: 0,
      geometryTypeId: '2',
      floor: 1,
      liveload: 2,
      location: {
        longitude: 56.169550783306505,
        latitude: 10.157270020329669,
        height: 13
      },
      visualInspection: [],
      type: 'ComponentType',
      reboundTest: []
    }
  ],
  geometries: [
    {
      _id: '0',
      componentCategory: ComponentCategory.Slab,
      crossSectionId: '0',
      length: 4800,
      type: 'GeometryType'
    },
    {
      _id: '1',
      componentCategory: ComponentCategory.Slab,
      crossSectionId: '0',
      length: 2400,
      type: 'GeometryType'
    },
    {
      _id: '2',
      componentCategory: ComponentCategory.Slab,
      crossSectionId: '0',
      length: 3600,
      type: 'GeometryType'
    },
    {
      _id: '3',
      componentCategory: ComponentCategory.Slab,
      crossSectionId: '1',
      length: 3600,
      type: 'GeometryType'
    },
    {
      _id: '4',
      componentCategory: ComponentCategory.Slab,
      crossSectionId: '2',
      length: 3600,
      type: 'GeometryType'
    }
  ],
  crossSections: [
    {
      _id: '0',
      crossSectionCategory: CrossSectionCategory.HollowCore,
      width: 2377,
      height: 180,
      moment: 0,
      shear: 0,
      normal: 0,
      rebarTypeId: '0',
      concreteMaterialTypeId: '',
      preStressStrandType: {
        force: 0,
        steelClass: '',
        steelDiameter: 0,
        amount: 0,
        date: '',
        location: {
          longitude: 0,
          latitude: 0,
          height: 0
        },
        manufacturerId: ''
      },
      type: 'CrossSectionType'
    },
    {
      _id: '1',
      crossSectionCategory: CrossSectionCategory.HollowCore,
      width: 1188,
      height: 180,
      moment: 0,
      shear: 0,
      normal: 0,
      rebarTypeId: '1',
      concreteMaterialTypeId: '',
      preStressStrandType: {
        force: 0,
        steelClass: '',
        steelDiameter: 0,
        amount: 0,
        date: '',
        location: {
          longitude: 0,
          latitude: 0,
          height: 0
        },
        manufacturerId: ''
      },
      type: 'CrossSectionType'
    },
    {
      _id: '2',
      crossSectionCategory: CrossSectionCategory.HollowCore,
      width: 1777,
      height: 180,
      moment: 0,
      shear: 0,
      normal: 0,
      rebarTypeId: '2',
      concreteMaterialTypeId: '',
      preStressStrandType: {
        force: 0,
        steelClass: '',
        steelDiameter: 0,
        amount: 0,
        date: '',
        location: {
          longitude: 0,
          latitude: 0,
          height: 0
        },
        manufacturerId: ''
      },
      type: 'CrossSectionType'
    }
  ],
  materials: [],
  rebars: [
    {
      _id: '0',
      rebarEntries: [
        {
          rebarDiameter: 12.5,
          rebarAmount: 8
        }
      ],
      rebarMaterialId: '',
      type: 'RebarType'
    },
    {
      _id: '1',
      rebarEntries: [
        {
          rebarDiameter: 12.5,
          rebarAmount: 4
        }
      ],
      rebarMaterialId: '',
      type: 'RebarType'
    },
    {
      _id: '2',
      rebarEntries: [
        {
          rebarDiameter: 12.5,
          rebarAmount: 6
        }
      ],
      rebarMaterialId: '',
      type: 'RebarType'
    }
  ]
};
